import { Component } from '@angular/core';
interface DashboardItem {
  name: string;
  count: number;
  status: string;
}

interface DashboardCategory {
  name: string;
  items: DashboardItem[];
}
@Component({
  selector: 'app-agent-dashboard',
  templateUrl: './agent-dashboard.component.html',
  styleUrls: ['./agent-dashboard.component.css']
})
export class AgentDashboardComponent {
  categories: DashboardCategory[] = [
    {
      name: 'AIR - Domestic',
      items: [
        { name: 'Pending Bookings', count: 0, status: 'pending' },
        { name: 'Pending Additional Service Requests', count: 0, status: 'completed' },
        { name: 'Pending Booking Refunds', count: 0, status: 'pending' },
        // Add more items as needed
      ]
    },
    {
      name: 'AIR - International',
      items: [
        { name: 'Pending Bookings', count: 0, status: 'completed' },
        { name: 'Pending Service Requests', count: 0, status: 'pending' },
        // Add more items as needed
      ]
    },
    {
      name: 'BUS',
      items: [
        { name: 'Pending Bookings', count: 0, status: 'completed' },
        { name: 'Pending Bookings for Other PG', count: 0, status: 'pending' },
      ]
    },
    {
      name: 'Hotel',
      items: [
        { name: 'Pending Bookings', count: 0, status: 'completed' },
        { name: 'Pending Booking Refunds', count: 0, status: 'critical' },
        // Add more items as needed
      ]
    },
    // Add more categories as needed
  ];

}
